import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({ method: 'PlayerData' });

    let { player } = result;
    let loggedIn = player ? true : false;

    if (loggedIn) {
        return {
            ...result,
            loggedIn: loggedIn,
            player: {
                ...result.player,
                name: result?.player?.first_name + ' ' + result?.player?.last_name,
            },
        };
    } else if (result.response) {
        return {
            loggedIn: false,
            errors: result.response.message,
        };
    } else {
        return {
            loggedIn: false,
            errors: 'Unspecified Error',
        };
    }
};
